import React from 'react'
import './Strips.scss'
import { formatDate } from './shared/js/utils'
import { preserveQueryParams } from 'utils/js/browser_helpers'

function Strip(props) {
    const handleControls = e => {
        let parent = e.target.parentElement
        let strip = parent.getElementsByClassName('video-strip')
        let clip = document.getElementsByClassName('clip')[0]
        let clip_length = clip.scrollWidth + 34

        if (strip.length !== 0) {
            strip = strip[0]
        }

        if ('fwd' === e.target.getAttribute('class')) {
            strip.scrollLeft += clip_length
        } else {
            strip.scrollLeft += -clip_length
        }
        props.handleClick()
    }

    const handleMobileControls = e => {
        let parent = e.target.parentElement.parentElement
        let strip = parent.getElementsByClassName('video-strip')

        if (strip.length !== 0) {
            strip = strip[0]
        }

        let disabled = parent.getElementsByClassName('disabled')
        if (disabled.length > 0) {
            disabled[0].classList.remove('disabled')
        }

        if ('next' === e.target.getAttribute('class')) {
            strip.scrollTop += 330

            if (strip.scrollTop + 330 >= strip.scrollHeight) {
                e.target.classList.add('disabled')
            }
        } else {
            strip.scrollTop += -330

            if (strip.scrollTop - 330 <= 0) {
                e.target.classList.add('disabled')
            }
        }
    }

    const { clips } = props.clips

    return (
        <div className="Strip__cont">
            <h2 className="section-heading">{props.title}</h2>
            <div className="wrap">
                <span className="back" onClick={handleControls} />
                <ul className="video-strip">
                    {clips.map((item, i) => {
                        const post_date = formatDate(item.post_date.replace(/-/g, '/'))

                        return (
                            <li
                                className="clip"
                                data-video-id={item.bc_video_id}
                                data-url={preserveQueryParams(item.href)}
                                key={`${i} + ${item.video_duration}`}
                                onClick={props.handleClick}
                            >
                                <div className="thumb-cont">
                                    <img
                                        className="thumb"
                                        src={item.featured_image_src}
                                        alt={item.post_title}
                                    />
                                    <span className="play" />
                                </div>
                                <h3>{item.post_title.replace('&amp;', '&')}</h3>
                                <div className="date">
                                    {item.video_duration} | {post_date}
                                </div>
                            </li>
                        )
                    })}
                </ul>
                <span className="fwd" onClick={handleControls} />
                <div className="mobile-controls visible-xs">
                    <span className="prev disabled" onClick={handleMobileControls}>
                        Prev 3
                    </span>{' '}
                    &nbsp; | &nbsp;
                    <span className="next" onClick={handleMobileControls}>
                        Next 3
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Strip
